export default {
    swiftCall: 'Swiftcall Connect',
    callBoxes: 'Callboxes',
    callNumber: 'Calling Phone Number',
    addCallBox: 'Add Callbox',
    editCallBox: 'Edit Callbox',
};
